import React, { useEffect, useState } from 'react';
import { Layout, Content, BackToTop } from '@sydney-broker-ui/core';
import './header/header.css';
import PropTypes from 'prop-types';
function BpClientPublicApp(props) {
  const [newLayout, setNewLayout] = useState(false);
  useEffect(() => {
    const path = window.location.pathname.split('/apps/ptb/').pop();
    if (path === 'public/contactus' || (path.includes('gateway/') && props?.route?.design === 1)) {
      setNewLayout(true);
    }
  }, []);

  return newLayout ? (
    <Layout className={`new-layout ${newLayout && 'enableMargin'}`}>
      <nav className="navbar navbar-fixed-top public-navbar">
        <div className="navtlbar">
          <div className="pageTitle">
            <a href="#" aria-label="home">
              <p className="ant-bp-pagetitle"> Producer Toolbox </p>
            </a>
          </div>
        </div>
      </nav>
      <Content noContainer>
        {props.children}
        <BackToTop />
      </Content>
    </Layout>
  ) : (
    <div className="bpAppContainer fluid-container">
      <nav className="navbar navbar-fixed-top public-navbar">
        <div className="navtlbar">
          <div className="pageTitle">
            <a href="#" aria-label="home">
              {/* <img src="/apps/ptb/images/Anthem_Inc.png" alt="Anthem Inc." /> */}
              <p className="ant-bp-pagetitle"> Producer Toolbox </p>
            </a>
          </div>
        </div>
      </nav>
      <div className="body-container">
        <BackToTop yThreshold="600" />
        {props.children}
      </div>
    </div>
  );
}

BpClientPublicApp.propTypes = {
  route: PropTypes.object,
  children: PropTypes.object,
};

export default BpClientPublicApp;
